import React, { Component } from 'react';
import { Panel, FormGroup, Button, Modal } from 'react-bootstrap';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { AlertList } from "react-bs-notifier";

import FormField from './../../components/FormField';

import { getURL } from './../../Utils';

import './GameplayHistoryGenerator.css';

class GameplayHistoryGenerator extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      roundID: '',
      host: '',
      isBusy: false,
      tokenURL: '',
      errorMessage: '',

      // alerts
      position: "top-right",
			alerts: [],
			timeout: 1000,
    }

    this.generateAlert = this.generateAlert.bind(this);
  }

  generateAlert() {
    const newAlert ={
      id: (new Date()).getTime(),
      type: "success",
      headline: "Success",
      message: "Copied to clipboard"
    };

    this.setState({
      alerts: [...this.state.alerts, newAlert]
    });
  }

  onAlertDismissed(alert) {
    const alerts = this.state.alerts;

    // find the index of the alert that was dismissed
    const index = alerts.indexOf(alert);

    if (index >= 0) {
      this.setState({
        // remove the alert from the array
        alerts: [...alerts.slice(0, index), ...alerts.slice(index + 1)]
      });
    }
  }

  onInputChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  generateURL() {
    let url = getURL();

    // remove trailing /
    if (url[url.length - 1] === '/') url = url.substring(0, url.length - 1);

    this.setState({
      isBusy: true,
      errorMessage: '',
      tokenURL: '',
    }, () => {
      fetch(`${url}/history-viewer/History`, 
      { 
        method: 'POST',
        body: JSON.stringify({ 
          RoundId: this.state.roundID, 
          Host: this.state.host,
          Account: {
            Username: "eviluser",
            Password: "evilpassword"
          },
        }),
        headers:{
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(json => {
        if (json.ErrorMessage) {
          this.setState({ isBusy: false, errorMessage: json.ErrorMessage })
        } else {
          this.setState({ isBusy: false, tokenURL: json.Url, errorMessage: '' })
        }
      })
      .catch(error => {
        this.setState({ isBusy: false, errorMessage: error.message })
      });
    });
  }

  render() {
    return [
      <AlertList
        key={'alert-list'}
        position={this.state.position}
        alerts={this.state.alerts}
        timeout={this.state.timeout}
        onDismiss={this.onAlertDismissed.bind(this)}
      />,
      <Modal 
        key={'modal'}
        show={true} 
        onHide={this.props.goBack} 
        className="gameplay-history-generator"
      >
        <Modal.Header closeButton>
          <Modal.Title>Gameplay History Generator</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel>
            <FormGroup>
              <FormField
                configID="roundID"
                label="RoundID"
                type="text"
                onChange={this.onInputChange.bind(this)}
                value={this.state.roundID}
              />
            </FormGroup>
            <FormGroup>
              <FormField
                configID="host"
                label="Host"
                type="text"
                onChange={this.onInputChange.bind(this)}
                value={this.state.host}
              />
            </FormGroup>
            {
              this.state.errorMessage && (
                <div className="gameplay-history-generator__error-message">
                  <p>{this.state.errorMessage}</p>
                  <p>Please check the browser console.</p>
                </div>
              )
            }
            {
              this.state.tokenURL && (
                <div className="gameplay-history-generator__token-url">
                  <div className="token-url__text">
                    <span>{this.state.tokenURL}</span>
                    <CopyToClipboard 
                      text={this.state.tokenURL} 
                      onCopy={this.generateAlert}
                    >
                      <button className="btn btn-xs btn-info btn-block">Copy to clipboard</button>
                    </CopyToClipboard>
                  </div>

                  <a target="_blank" href={this.state.tokenURL}>Click here to go to the generated gameplay history link</a>
                </div>
              )
            }
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button 
            bsStyle="default"
            style={{ marginRight: '10px' }}
            onClick={this.props.goBack}
            disabled={this.state.isBusy}
          >Cancel</Button>
          <Button bsStyle="info" onClick={_ => this.generateURL()} disabled={this.state.isBusy}>Generate</Button>
        </Modal.Footer>
      </Modal>
    ]
  }
}

export default GameplayHistoryGenerator;


// WEBPACK FOOTER //
// ./src/pages/GameplayHistoryGenerator/GameplayHistoryGenerator.jsx